import { render, staticRenderFns } from "./CPDueDiligenceStageContainer.vue?vue&type=template&id=28e8b1f4&scoped=true&"
import script from "./CPDueDiligenceStageContainer.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceStageContainer.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceStageContainer.vue?vue&type=style&index=0&id=28e8b1f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8b1f4",
  null
  
)

export default component.exports